import React, { useContext } from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { useFetchBusinessLocations } from '../../../api/hooks/useFetchBusinessLocations';
import { useFetchRequestAccessForm } from '../../../api/hooks/useFetchRequestAccessForm';
import { convertBusinessLocationsData } from '../utils';
import SelectionModal from './index';
import { SelectionListItem } from '../../../contexts/types';
import { RequestAccessFormContext } from '../../../contexts/request-access-form-context';

type SelectionModalLocationProps = {
    title: string;
    subtitle: string;
    showModal: boolean;
    onAdd: (items: SelectionListItem[]) => void;
    onClose: () => void;
};

const SelectionModalLocation = (props: SelectionModalLocationProps) => {
    const { selectedLocations, selectedAccounts } = useContext(RequestAccessFormContext);
    const { accessId } = useParams();

    const { data, isLoading, isFetchingNextPage, isError, fetchNextPage } =
        useFetchBusinessLocations({
            directoryUserAccountAccountId: selectedAccounts[0]?.id,
        });

    const { translations } = useFetchRequestAccessForm();

    if (isError) return <Navigate to={`/${accessId}/error`} replace={true} />;

    const items = convertBusinessLocationsData({
        businessLocations: data?.pages || [],
        selectedLocations,
        translations: translations || {},
    });

    const subtitleNoItems = 'app.request.access.public.step.2.google.profile.modal.no.items';

    return (
        <SelectionModal
            items={items}
            fetchNextPage={fetchNextPage}
            isLoading={isLoading}
            isFetchingNextPage={isFetchingNextPage}
            {...props}
            subtitle={items.length > 0 ? props.subtitle : subtitleNoItems}
        />
    );
};

export default SelectionModalLocation;
